var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5335_5681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5C7.21624 0.5 0.5 7.2153 0.5 15.5C0.5 23.7838 7.21624 30.5 15.5 30.5C23.7847 30.5 30.5 23.7838 30.5 15.5C30.5 7.2153 23.7847 0.5 15.5 0.5ZM15.5 28.625C8.25128 28.625 2.37503 22.7487 2.37503 15.5C2.37503 8.25128 8.25128 2.37503 15.5 2.37503C22.7487 2.37503 28.625 8.25128 28.625 15.5C28.625 22.7487 22.7487 28.625 15.5 28.625Z",
    fill: "#0054A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3922 16.8059L16.4468 21.6809V7.06248C16.4468 6.54495 16.0231 6.125 15.4999 6.125C14.9768 6.125 14.553 6.54503 14.553 7.06248V21.6809L9.60771 16.8059C9.23833 16.4403 8.63836 16.4403 8.26898 16.8059C7.8996 17.1725 7.8996 17.7659 8.26898 18.1315L14.8305 24.5993C15.0059 24.7747 15.2524 24.875 15.4999 24.875C15.7465 24.875 15.9931 24.7738 16.1693 24.6003L22.7309 18.1325C23.1012 17.7659 23.1003 17.1725 22.7309 16.8068C22.3616 16.4403 21.7615 16.4403 21.3922 16.8059Z",
    fill: "#0054A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5335_5681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4292cccfd1bf5d24e82227cb3a22da17.svg";
export { ForwardRef as ReactComponent };